import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import { RWebShare } from "react-web-share";
import { Modal, ModalBody, ModalHeader, Row } from "reactstrap";
import { bindActionCreators } from "redux";
import Swal from "sweetalert2";
import { requestExpenseList, requestExpenseSave, requestGetExpenseById, requestExpenseUpdate, requestExpenseDelete } from "../../Redux/actions";
import Footer from './../footer';
import PageHeader from './../header';
import Sidebar from './../Sidebar';
import '../../Admin/style.css';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import DataTable from 'react-data-table-component';
import { addDegreeAdmin, currencyAdmin } from "../../Redux/sagas";

function ExpenseList(props) {
    const params = useParams();
    const [jobs, setjobs] = useState([]);
    // const [pagination, setpagination] = useState({});
    const navigate = useNavigate();
    const [pages, setpages] = useState([]);
    const [page_size, setpage_size] = useState(10);
    const [change, setchange] = useState(false);
    const [totalRows, setTotalRows] = useState(0);
    const [search, setSearch] = useState('');
    const [filter, setFilter] = useState([]);
    const [logindetails, setlogindetails] = useState({});
    const [statusdata, setstatusdata] = useState({ status: 0 });
    const [typingTimeout, setTypingTimeout] = useState(0);
    const [id, setid] = useState(0);
    const [addmodal, setaddModal] = useState(false);
    const [editmodal, seteditmodal] = useState(false);
    const [selectedCheckboxes, setSelectedCheckboxes] = useState([]);
    const [checked_all, setCheckedAll] = useState(false);
    const baseUrl = process.env.REACT_APP_BASE_URL;
    const [errorDetails, seterrorDetails] = useState("");
    const [errorDate, seterrorDate] = useState("");
    const [errorTime, seterrorTime] = useState("");
    const [errorAmount, seterrorAmount] = useState("");
    const [errorAccount, seterrorAccount] = useState("");
    const [errorPerson, seterrorPerson] = useState("");

    const getCurrentTime = () => {
        const now = new Date();
        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');
        return `${hours}:${minutes}`;
    };

    const [adddata, setadddata] = useState({
        date: new Date().toISOString().split('T')[0], details: "", account: "", amount: 0, person: "",
        time: getCurrentTime(), cashIn: 0, bankName: "", current: 0
    });
    const [editdata, seteditdata] = useState({
        date: "", details: "", account: "", amount: 0, person: "",
        time: getCurrentTime(), cashIn: 0, bankName: "", current: 0
    });

    function accountadd(value) {
        console.log(value);
        if (!value) {
            seterrorAccount("*Select Account.");
            return false;
        } else {
            seterrorAccount("");
            return true;
        }
    }

    function accountedit() {
        let formIsValid = false;
        if (!editdata["account"]) {
            formIsValid = false;
            seterrorAccount("*Select Account.");
        } else {
            formIsValid = true;
            seterrorAccount("");
        }
        return formIsValid;
    }

    function validateEditAmount() {
        let formIsValid = false;
        if (!editdata.amount) {
            formIsValid = false;
            seterrorAmount("*Enter Amount.");
        } else if (!/^\d{1,7}$/.test(editdata.amount)) {
            formIsValid = false;
            seterrorAmount("*Enter valid Amount.");
        } else {
            formIsValid = true;
            seterrorAmount("");
        }
        return formIsValid;
    }

    function validateEditDate() {
        let formIsValid = false;

        if (!editdata.date) {
            formIsValid = false;
            seterrorDate("*Enter a date.");
        }
        // Optional: Ensure the date is not in the past
        else if (new Date(editdata.date) < new Date(new Date().toISOString().split('T')[0])) {
            formIsValid = false;
            seterrorDate("*Date cannot be in the past.");
        }
        else {
            formIsValid = true;
            seterrorDate("");
        }

        return formIsValid;
    }

    function validateEditTime() {
        let formIsValid = false;

        if (!editdata.time) {
            formIsValid = false;
            seterrorTime("*Enter a time.");
        }
        // Optional: Validate format HH:MM (24-hour)
        else if (!/^([01]\d|2[0-3]):([0-5]\d)$/.test(editdata.time)) {
            formIsValid = false;
            seterrorTime("*Enter valid time in HH:MM format.");
        }
        else {
            formIsValid = true;
            seterrorTime("");
        }
        return formIsValid;
    }

    function validateEditDetails() {
        let formIsValid = false;
        if (!editdata.details) {
            formIsValid = false;
            seterrorDetails("*Enter Details.");
        } else {
            formIsValid = true;
            seterrorDetails("");
        }
        return formIsValid;
    }

    function validateEditPerson() {
        let formIsValid = false;
        if (!editdata.details) {
            formIsValid = false;
            seterrorPerson("*Enter Details.");
        } else {
            formIsValid = true;
            seterrorPerson("");
        }
        return formIsValid;
    }

    function validateEditForm() {
        let amount = validateEditAmount(); let details = validateEditDetails(); let date = validateEditDate(); let time = validateEditTime();
        let account = accountedit(); let person = validateEditPerson();
        let valid = amount && details && date && time && person;
        if (!valid) {
            Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Please fill all the required fields correctly.",
            });
        }
        return valid;
    }

    function validateAddAmount() {
        let formIsValid = false;
        if (!adddata.amount) {
            formIsValid = false;
            seterrorAmount("*Enter Amount.");
        } else if (!/^\d{1,7}$/.test(adddata.amount)) {
            formIsValid = false;
            seterrorAmount("*Enter valid Amount.");
        } else {
            formIsValid = true;
            seterrorAmount("");
        }
        return formIsValid;
    }

    function validateAddDate() {
        let formIsValid = false;

        if (!adddata.date) {
            formIsValid = false;
            seterrorDate("*Enter a date.");
        }
        // Optional: Ensure the date is not in the past
        else if (new Date(adddata.date) < new Date(new Date().toISOString().split('T')[0])) {
            formIsValid = false;
            seterrorDate("*Date cannot be in the past.");
        }
        else {
            formIsValid = true;
            seterrorDate("");
        }

        return formIsValid;
    }

    function validateAddTime() {
        let formIsValid = false;

        if (!adddata.time) {
            formIsValid = false;
            seterrorTime("*Enter a time.");
        }
        // Optional: Validate format HH:MM (24-hour)
        else if (!/^([01]\d|2[0-3]):([0-5]\d)$/.test(adddata.time)) {
            formIsValid = false;
            seterrorTime("*Enter valid time in HH:MM format.");
        }
        else {
            formIsValid = true;
            seterrorTime("");
        }
        return formIsValid;
    }

    function validateAddDetails() {
        let formIsValid = false;
        if (!adddata.details) {
            formIsValid = false;
            seterrorDetails("*Enter Details.");
        } else {
            formIsValid = true;
            seterrorDetails("");
        }
        return formIsValid;
    }

    function validateAddPerson() {
        let formIsValid = false;
        if (!adddata.person) {
            formIsValid = false;
            seterrorPerson("*Enter Person.");
        } else {
            formIsValid = true;
            seterrorPerson("");
        }
        return formIsValid;
    }

    function validateAddForm() {
        let amount = validateAddAmount(); let details = validateAddDetails(); let date = validateAddDate(); let time = validateAddTime();
        let account = accountadd(); let person = validateAddPerson();
        let valid = amount && details && date && time && person;
        if (!valid) {
            Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Please fill all the required fields correctly.",
            });
        }
        return valid;
    }

    // Function to handle individual checkbox change
    const handleCheckboxChange = (id) => {
        console.log("Checkbox clicked:", id);
        const updatedCheckboxes = selectedCheckboxes.includes(id)
            ? selectedCheckboxes.filter((checkboxId) => checkboxId !== id)
            : [...selectedCheckboxes, id];
        setSelectedCheckboxes(updatedCheckboxes);
    };

    const Checkbox = ({ id, isChecked, onChange, name, value }) => (
        <input type="checkbox" name={name} value={value} id={id} checked={isChecked} onChange={() => onChange(id)} />
    );

    // Function to handle "Select All" checkbox change
    const handleSelectAllChange = () => {
        const allCheckboxIds = filter.map((item) => item.cartId);
        setSelectedCheckboxes((prevSelected) =>
            prevSelected.length === allCheckboxIds.length ? [] : allCheckboxIds
        );
    };

    const onchangeeditdata = (event) => {
        seteditdata((editdata) => ({
            ...editdata,
            [event.target.name]: event.target.value,
        }));
    };

    const onchangeadddata = (event) => {
        setadddata((adddata) => ({
            ...adddata,
            [event.target.name]: event.target.value,
        }));
    };

    const addtoggle = () => setaddModal(!addmodal);

    const saveaddtoggle = (e) => {
        e.preventDefault();
        try {
            if (validateAddForm()) {
                console.log(logindetails.data.userToken);
                props.requestExpenseSave({
                    data: {
                        userToken: logindetails.data.userToken,
                        //      compToken: localStorage.getItem('companyToken'),
                        compToken: '611337539322',
                        date: adddata.date,
                        time: adddata.time,
                        details: adddata.details,
                        account: adddata.account,
                        amount: adddata.amount,
                        cashIn: adddata.cashIn,
                        bankName: adddata.bankName,
                        person: adddata.person,
                        ob: 0
                    },
                });
                setadddata({
                    date: new Date().toISOString().split('T')[0], details: "", account: "", amount: 0,
                    time: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }), cashIn: 0, bankName: ""
                });
                addtoggle();
            }
        }
        catch (err) {
            console.error("Error in saveaddtoggle:", err);
        }
    };

    useEffect(() => {
        let addData = props.data.expenseSaveData;
        console.log(addData);
        if (addData !== undefined) {
            if (addData.data.status === 1) {

                Swal.fire({
                    title: "Good job!",
                    text: addData.data.message,
                    icon: "success",
                });
                setchange(!change);
            }
        }
        props.data.expenseSaveData = undefined;
        addData = undefined;
    }, [props.data.expenseSaveData]);

    const edittoggle = (id) => {
        if (editmodal === true) {
            seteditmodal(!editmodal);
        } else {
            seteditmodal(!editmodal);
            setid(id);
            console.log(logindetails.data.userToken);
            props.requestGetExpenseById({
                data: {
                    param2: id.toString(),
                    param1: '611337539322', //localStorage.getItem('companyToken')
                    token: logindetails.data.userToken
                },
            });
        }
    };

    useEffect(() => {
        let itemData = props.data.expenseByIdData;
        console.log(itemData);
        if (itemData !== undefined) {
            if (itemData.data) {
                seteditdata(itemData.data.data);
                const isoDate = itemData.data.data.date
                const formattedDate = isoDate.split('T')[0]; // "2025-07-09"

                seteditdata(prev => ({
                    ...prev,
                    date: formattedDate
                }));
            }
        }
    }, [props.data.expenseByIdData]);

    const saveedittoggle = (e) => {
        e.preventDefault();
        if (validateEditForm()) {
            props.requestExpenseUpdate({
                data: {
                    id: id,
                    userToken: logindetails.data.userToken,
                    //      compToken: localStorage.getItem('companyToken'),
                    compToken: '611337539322',
                    date: editdata.date,
                    time: editdata.time,
                    details: editdata.details,
                    account: editdata.account,
                    amount: editdata.amount,
                    cashIn: editdata.cashIn,
                    bankName: editdata.bankName,
                    person: adddata.person
                },
            });
            seteditdata({
                date: new Date().toISOString().split('T')[0], details: "", account: "", amount: 0,
                time: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }), cashIn: 0, bankName: ""
            });
            setid(0);
            edittoggle();
        }
    }

    useEffect(() => {
        let statusJobData = props.data.expenseUpdateData;
        if (statusJobData !== undefined) {
            if (statusJobData?.data?.status == 1) {
                Swal.fire(
                    "Good job!",
                    statusJobData?.data?.message,
                    "success"
                );
                props.data.expenseUpdateData = undefined;
                statusJobData = undefined;
                setchange(!change);
            } else {
                Swal.fire("Error!", `${statusJobData.data.message}`, "error");
                props.data.expenseUpdateData = undefined;
            }
        }
    }, [props.data.expenseUpdateData]);

    const handleSearch = (event) => {
        console.log(event.target.value);
        setSearch(event.target.value);
    };

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0'); // Ensures 2 digits
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
        const year = date.getFullYear();

        return `${day} / ${month} / ${year}`;
    };

    const columns = [
        {
            name: 'Select',
            cell: item => <div>
                <Checkbox id={item.Id} name="select" value={item.Id} onChange={() => handleCheckboxChange(item.Id)} isChecked={selectedCheckboxes.includes(item.Id)}></Checkbox>
            </div>,
            selector: item => item.Id,
            width: '1%'
        },
        {
            name: 'Date',
            cell: item => <div><h6>{formatDate(item.date.substring(0, 10))} {item.time}</h6></div>,
            selector: item => item.date,
            width: '15%'
        },
        {
            name: 'Details',
            cell: item => <div><h6>{item.details}</h6></div>,
            selector: item => item.details,
            width: '15%'
        },
        {
            name: 'Account',
            cell: item => <div><h6>{item.account}</h6></div>,
            selector: item => item.account,
            width: '15%'
        },
        {
            name: 'In / Out',
            cell: item => <div><h6>{item.cashIn === 1 ? 'Cash In' : 'Cash Out'}</h6></div>,
            selector: item => item.quantity,
            width: '10%'
        },
        {
            name: 'Amount',
            cell: item => <div><h6>{item.amount}</h6></div>,
            selector: item => item.amount,
            width: '5%'
        },
        {
            name: 'Current',
            cell: item => <div><h6>{item.current}</h6></div>,
            selector: item => item.current,
            width: '10%'
        },
        {
            name: 'Action',
            cell: item => <div>
                <button class="badge badge-opacity-warning" style={{ border: "0px", marginLeft: "5px", }}
                    onClick={() => { edittoggle(item.id); }}><i className="fa fa-edit"></i></button>
                {editmodal === true && (
                    <Modal
                        isOpen={editmodal}
                        toggle={edittoggle}
                    >
                        <ModalHeader toggle={edittoggle}>
                            Update Product
                        </ModalHeader>
                        <ModalBody>
                            <form class="forms-sample">
                                <div class="form-group">
                                    <label>Date</label>
                                    <input
                                        type="date"
                                        class="form-control"
                                        placeholder="Date"
                                        name="date"
                                        value={editdata.date}
                                        onBlur={validateEditDate}
                                        onChange={onchangeeditdata}
                                    />
                                    {errorDate && <p>{errorDate}</p>}
                                </div>
                                <div class="form-group">
                                    <label>Time</label>
                                    <input
                                        type="time"
                                        class="form-control"
                                        placeholder="Time"
                                        name="time"
                                        value={editdata.time}
                                        onChange={onchangeeditdata}
                                    />
                                </div>
                                <div class="form-group">
                                    <label>Person</label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        placeholder="Person"
                                        name="person"
                                        value={editdata.person}
                                        onBlur={validateEditPerson}
                                        onChange={onchangeeditdata}
                                    />
                                    {errorPerson && <p>{errorPerson}</p>}
                                </div>
                                <div class="form-group">
                                    <label>Details</label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        placeholder="Details"
                                        name="details"
                                        value={editdata.details}
                                        onBlur={validateEditDetails}
                                        onChange={onchangeeditdata}
                                    />
                                    {errorDetails && <p>{errorDetails}</p>}
                                </div>
                                <div class="form-group">
                                    <label>Account</label>
                                    <select
                                        class="form-select"
                                        name="account"
                                        value={editdata.account}
                                        onBlur={accountedit}
                                        onChange={onchangeeditdata}
                                    >
                                        <option value="0">Office</option>
                                        <option value="0">Personal</option>
                                    </select>
                                </div>
                                <div class="form-group">
                                    <label>Amount</label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        placeholder="Amount"
                                        name="amount"
                                        value={editdata.amount}
                                        onBlur={validateEditAmount}
                                        onChange={onchangeeditdata}
                                    />
                                    {errorAmount && <p>{errorAmount}</p>}
                                </div>
                                <button
                                    type="submit" class="btn btn-primary me-2" onClick={saveedittoggle} >
                                    Update
                                </button>
                                <button
                                    class="btn btn-light"
                                    onClick={edittoggle}
                                >
                                    Cancel
                                </button>
                            </form>
                        </ModalBody>
                    </Modal>
                )}
                <button class="badge badge-opacity-danger" style={{ border: "0px", background: "#fea8a9", marginLeft: "5px", }}
                    onClick={() => { deletedata(item.id); }}><i class="fa fa-trash"></i></button>
            </div>,
            selector: item => item.id,
            width: '100px'
        },
    ];

    function deletedata(id) {
        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
            if (result.isConfirmed) {
                props.requestExpenseDelete({
                    data: {
                        token: logindetails.data.userToken,
                        param1: id.toString()
                    },
                });
            }
        })
    }

    //delete
    useEffect(() => {
        let deleteData = props.data.expenseDeleteData;
        console.log(deleteData);
        if (deleteData !== undefined) {
            if (deleteData.data.status === 1) {
                Swal.fire({
                    title: 'Good job!',
                    text: deleteData.data.message,
                    icon: 'success'
                });
                setchange(!change)
            }
            else {
                Swal.fire({
                    title: 'Error!',
                    text: deleteData.data.message,
                    icon: 'error'
                })
            }
        }
        props.data.expenseDeleteData = undefined;
        deleteData = undefined;
    }, [props.data.expenseDeleteData]);

    useEffect(() => {
        let data1 = JSON.parse(localStorage.getItem("user"));
        if (data1) {
            setlogindetails(data1);
            props.requestExpenseList({
                //      token: localStorage.getItem('companyToken'),
                token: '611337539322',
                page: params.page,
                page_size: params.page_size,
                search: 'a'
            });
        }
        setpage_size(params.page_size);
    }, [params.page, params.page_size, change]);

    function onChangePageSize(e) {
        setpage_size(e.target.value);
        if (e.target.value > 0) {
            navigate(`/expenselist/1/${e.target.value}`);
        }
    }

    //set job list
    useEffect(() => {
        let jobsData = props.data.expenseListData;
        console.log(jobsData);
        if (jobsData !== undefined) {
            if (jobsData.data) {
                setjobs(jobsData.data.data);
                setFilter(jobsData.data.data);
                // setTotalRows(jobsData.data.meta.total);
            }
        }
    }, [props.data.expenseListData]);

    const handlePageChange = page => {
        console.log(page);
        props.requestExpenseList({
            page: page,
            page_size: page_size,
            search: 'a'
        });
    }

    const handlePerRowsChange = async (newPerPage, page) => {
        setpage_size(newPerPage);
        props.requestExpenseList({
            page: page,
            page_size: newPerPage,
            search: 'a'
        });
    }

    function printPage() {
        var printContents = "<br/><center><h3>Jobs</h3></center>" + document.getElementById("printme").innerHTML;
        var originalContents = document.body.innerHTML;
        document.body.innerHTML = printContents;
        window.print();
        document.body.innerHTML = originalContents;
    }

    function HandleAddProduct() {

    }

    const tableHeaderStyle = {
        headCells: {
            style: {
                fontWeight: "bold",
                fontSize: "14px"
            },
        },
    }

    return (
        <>
            <div class="container-scroller">
                {/* <PageHeader name="Jobs" /> */}
                <div class="container-fluid page-body-wrapper">
                    <Sidebar name="Jobs" />
                    <div class="main-panel">
                        <div class="content-wrapper">
                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="home-tab">
                                        <div class="row flex-grow">
                                            <div class="col-12 grid-margin stretch-card">
                                                <div class="card card-rounded">
                                                    <div class="card-body">
                                                        <div class="d-sm-flex justify-content-between align-items-start">
                                                            <div class="btn-wrapper">
                                                                <RWebShare
                                                                    data={{
                                                                        text: "BookkeeperDay - Your Personal Bookkeeping App",
                                                                        url: `${baseUrl}/cart/${params.page}/${params.page_size}`,
                                                                        title: "Cart List",
                                                                    }}
                                                                >
                                                                    <p class="btn btn-otline-dark align-items-center"><i class="icon-share"></i> Share</p>
                                                                </RWebShare>
                                                                <button onClick={printPage} class="btn btn-otline-dark"><i class="icon-printer"></i> Print</button>
                                                            </div>
                                                        </div>
                                                        <div class="card">
                                                            <div class="card-body">
                                                                <button class="btn btn-primary" style={{ color: '#fff' }} onClick={addtoggle}>Add Expense</button>
                                                                {addmodal === true && (
                                                                    <Modal
                                                                        isOpen={addmodal}
                                                                        toggle={addtoggle}
                                                                    >
                                                                        <ModalHeader toggle={addtoggle}>
                                                                            Add Expense
                                                                        </ModalHeader>
                                                                        <ModalBody>
                                                                            <form class="forms-sample">
                                                                                <div class="form-group">
                                                                                    <label>Date</label>
                                                                                    <input
                                                                                        type="date"
                                                                                        class="form-control"
                                                                                        placeholder="Date"
                                                                                        name="date"
                                                                                        value={adddata.date}
                                                                                        onBlur={validateAddDate}
                                                                                        onChange={onchangeadddata}
                                                                                    />
                                                                                    {errorDate && <p>{errorDate}</p>}
                                                                                </div>
                                                                                <div class="form-group">
                                                                                    <label>Time</label>
                                                                                    <input
                                                                                        type="time"
                                                                                        class="form-control"
                                                                                        placeholder="Time"
                                                                                        name="time"
                                                                                        value={adddata.time}
                                                                                        onChange={onchangeadddata}
                                                                                    />
                                                                                </div>
                                                                                <div class="form-group">
                                                                                    <label>Person</label>
                                                                                    <input
                                                                                        type="text"
                                                                                        class="form-control"
                                                                                        placeholder="Person"
                                                                                        name="person"
                                                                                        value={adddata.person}
                                                                                        onBlur={validateAddPerson}
                                                                                        onChange={onchangeadddata}
                                                                                    />
                                                                                    {errorPerson && <p>{errorPerson}</p>}
                                                                                </div>
                                                                                <div class="form-group">
                                                                                    <label>Details</label>
                                                                                    <input
                                                                                        type="text"
                                                                                        class="form-control"
                                                                                        placeholder="Details"
                                                                                        name="details"
                                                                                        value={adddata.details}
                                                                                        onBlur={validateAddDetails}
                                                                                        onChange={onchangeadddata}
                                                                                    />
                                                                                    {errorDetails && <p>{errorDetails}</p>}
                                                                                </div>
                                                                                <div class="form-group">
                                                                                    <label>Account</label>
                                                                                    <select
                                                                                        class="form-select"
                                                                                        name="account"
                                                                                        value={adddata.account}
                                                                                        onChange={(e) => {
                                                                                            onchangeadddata(e); // update state
                                                                                            // accountadd(e.target.value); // validate with new value
                                                                                        }}
                                                                                    >
                                                                                        <option value="Office">Office</option>
                                                                                        <option value="Personal">Personal</option>
                                                                                    </select>
                                                                                </div>
                                                                                <div class="form-group">
                                                                                    <label>Amount</label>
                                                                                    <input
                                                                                        type="text"
                                                                                        class="form-control"
                                                                                        placeholder="Amount"
                                                                                        name="amount"
                                                                                        value={adddata.amount}
                                                                                        onBlur={validateAddAmount}
                                                                                        onChange={onchangeadddata}
                                                                                    />
                                                                                    {errorAmount && <p>{errorAmount}</p>}
                                                                                </div>
                                                                                <button
                                                                                    type="submit" class="btn btn-primary me-2" onClick={saveaddtoggle} >
                                                                                    Save
                                                                                </button>
                                                                                <button
                                                                                    class="btn btn-light"
                                                                                    onClick={addtoggle}
                                                                                >
                                                                                    Cancel
                                                                                </button>
                                                                            </form>
                                                                        </ModalBody>
                                                                    </Modal>
                                                                )}
                                                            </div>
                                                        </div>
                                                        <div class="table-responsive  mt-1" id="printme">
                                                            <DataTable
                                                                columns={columns}
                                                                data={filter}
                                                                pagination
                                                                paginationServer
                                                                paginationTotalRows={totalRows}
                                                                onChangePage={handlePageChange}
                                                                onChangeRowsPerPage={handlePerRowsChange}
                                                                actions={<button className="btn btn-success">Export to PDF</button>}
                                                                subHeader
                                                                subHeaderComponent={
                                                                    <input id="search" type="text" className="w-25 form-control" placeholder="Search..." value={search} onChange={handleSearch} />
                                                                }
                                                                customStyles={tableHeaderStyle}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* <Footer /> */}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

const mapStateToProps = (state) => {
    return { data: state.data };
};

const mapDispatchToProps = (dispatch) =>
    bindActionCreators({ requestExpenseList, requestExpenseSave, requestGetExpenseById, requestExpenseUpdate, requestExpenseDelete }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ExpenseList);